import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d603a92"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import Loader from "@/components/chat/chatContainer/Loader.vue";
import { ref, onMounted, watch } from "vue";
import { GetterTypes, MutationTypes, store } from "@/store";
import { LayoutBackgroundColorTypes } from "@/store/app/state";
import { useStore } from "vuex";
import { getIsMyMessageClass } from "@/utils/chat";
import { getImageAttachmentStyles } from "@/utils/attachment";
import { useComputedValue } from "@/composables";
import { Attachment, NonAutomaticMessage } from "@/store/chats/types";

interface Props {
  attachment: Attachment;
  isShrinked?: boolean;
  galleryMode?: boolean;
  message: NonAutomaticMessage;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageAttachment',
  props: {
    attachment: {},
    isShrinked: { type: Boolean, default: false },
    galleryMode: { type: Boolean, default: false },
    message: {}
  },
  setup(__props: any) {

const props = __props;

onMounted(() => {
  getAppliedStyle();
});

const { commit } = useStore();
const appliedStyle = ref<{ width: string; height: string } | null>(null);
const temporaryColorBottom = ref<string | null>(null);
const temporaryColorTop = ref<string | null>(null);
const src = useComputedValue<string | undefined>(
  GetterTypes.GET_FULL_SIZE_IMAGE,
);
const colorBottom = useComputedValue<LayoutBackgroundColorTypes>(
  GetterTypes.GET_LAYOUT_BG_COLOR_BOTTOM,
);
const colorTop = useComputedValue<LayoutBackgroundColorTypes>(
  GetterTypes.GET_LAYOUT_BG_COLOR_TOP,
);
const authId = useComputedValue<number>(GetterTypes.GET_AUTH_ID);

const getAppliedStyle = async () => {
  const appliedStyles = await getImageAttachmentStyles({
    width: props.attachment?.width,
    height: props.attachment?.height,
    galleryMode: props.galleryMode,
    isShrinked: props.isShrinked,
    url: props.attachment?.url,
  });
  if (!appliedStyles) {
    return;
  }
  appliedStyle.value = appliedStyles;
};

watch(src, () => {
  updateImageSrc();
});
const openImage = () => {
  if (props.isShrinked || !props.attachment.url) {
    return;
  }
  temporaryColorBottom.value = colorBottom.value;
  temporaryColorTop.value = colorTop.value;
  store.commit(MutationTypes.SET_FULL_SIZE_IMAGE, props.attachment.url);
};

const updateImageSrc = () => {
  let resultColorBottom = temporaryColorBottom.value;
  let resultColorTop = temporaryColorTop.value;
  if (src.value) {
    resultColorBottom = LayoutBackgroundColorTypes.BLACK;
    resultColorTop = LayoutBackgroundColorTypes.BLACK;
  }

  commit(MutationTypes.SET_LAYOUT_BACKGROUND_COLOR_TOP, resultColorTop);
  commit(MutationTypes.SET_LAYOUT_BACKGROUND_COLOR_BOTTOM, resultColorBottom);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["attachment-image", [
      _unref(getIsMyMessageClass)(_ctx.message, _unref(authId)),
      { gallery: _ctx.galleryMode, isShrinked: _ctx.isShrinked },
    ]]),
    onClick: openImage
  }, [
    _createElementVNode("img", {
      loading: "lazy",
      style: _normalizeStyle(appliedStyle.value),
      src: _ctx.attachment.url
    }, null, 12, _hoisted_1),
    (_ctx.attachment?.uploadProgress !== undefined && !_ctx.attachment?.uploaded)
      ? (_openBlock(), _createBlock(Loader, {
          key: 0,
          progress: _ctx.attachment.uploadProgress,
          overlay: true
        }, null, 8, ["progress"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})